import { render, staticRenderFns } from "./MigrationLog.vue?vue&type=template&id=6a9ea026&"
import script from "./MigrationLog.vue?vue&type=script&lang=js&"
export * from "./MigrationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports